import React, { useState } from "react";
import { BarChart3, BrainCircuit, ShieldCheck, Users2 } from "lucide-react";
import AdminListComponent from "./AdminListComponent";
import SmartAnalyticsCandidatesTab from "./SmartAnalyticsCandidatesTab";
import SmartAnalyticsRecruitersTab from "./SmartAnalyticsRecruitersTab";

const TABS = [
  { key: "CANDIDATES", label: "Candidates", icon: Users2 },
  { key: "RECRUITERS", label: "Recruiters", icon: BrainCircuit },
  { key: "ADMIN", label: "Admin List", icon: ShieldCheck },
] as const;

type SmartAnalyticsTab = (typeof TABS)[number]["key"];

const SmartAnalyticsComponent = () => {
  const [activeTab, setActiveTab] = useState<SmartAnalyticsTab>("RECRUITERS");

  return (
    <div className="space-y-6">
      <div className="rounded-3xl border border-slate-800 bg-slate-900/40 p-6">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div>
            <h1 className="flex items-center gap-2 text-lg font-black text-slate-100">
              <BarChart3 className="h-5 w-5 text-cyan-400" />
              Smart Analytics
            </h1>
            <p className="mt-1 max-w-2xl text-xs font-semibold leading-relaxed text-slate-500">
              Cross-section view of candidates, recruiting organizations, and platform admins.
            </p>
          </div>
          <span className="flex items-center gap-2 rounded-full border border-cyan-500/30 bg-cyan-500/10 px-3 py-1.5 text-[10px] font-black uppercase tracking-wider text-cyan-400">
            <ShieldCheck className="h-3.5 w-3.5" />
            Super admin only
          </span>
        </div>

        <div className="mt-5 flex flex-wrap gap-2">
          {TABS.map((tab) => {
            const Icon = tab.icon;
            const active = activeTab === tab.key;
            return (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActiveTab(tab.key)}
                className={`flex items-center gap-2 rounded-xl px-4 py-2.5 text-xs font-black uppercase tracking-wider transition ${
                  active
                    ? "border border-cyan-500/40 bg-cyan-500/15 text-cyan-300"
                    : "border border-slate-800 bg-slate-950/60 text-slate-500 hover:border-slate-700 hover:text-slate-300"
                }`}
              >
                <Icon className="h-4 w-4" />
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      {activeTab === "CANDIDATES" && <SmartAnalyticsCandidatesTab />}
      {activeTab === "RECRUITERS" && <SmartAnalyticsRecruitersTab />}
      {activeTab === "ADMIN" && <AdminListComponent />}
    </div>
  );
};

export default SmartAnalyticsComponent;
